module.exports = __webpack_public_path__ + "static/media/AeonDisk.6a4946aa.png";